/**
 * 화면 이벤트 (명세 v1.3 10장, 귀인도감 services/track.js 와 같은 자리, D44) — POST /api/events.
 *
 * - **개인정보를 싣지 않습니다.** 호칭 · 대화 · 이메일은 오지 않습니다. 화면 자리(경로 첫 칸), 머문 시간 같은 것만
 * - **화면을 막지 않습니다.** 기다리지 않고, 실패해도 아무도 모릅니다
 * - 로그인했으면 fetch keepalive 로 그 단골 이름을 실어 보내고(페이지가 닫혀도 보내짐), 안 되면 sendBeacon(이름 없이)
 * - 모르는 이름은 보내지 않습니다. 서버가 같은 목록으로 거절합니다
 */
import { CLIENT_EVENT_NAMES } from '@config/events/index.js';
import { API_BASE } from './client.js';
import { useSession } from '../stores/session.js';

const NAMES = new Set(CLIENT_EVENT_NAMES);

/** 경로의 첫 칸만(/chats/son → /chats). id · 멤버를 넘기지 않습니다 */
export function pathKey(pathname = typeof window === 'undefined' ? '/' : window.location.pathname) {
    const first = String(pathname).split('/').filter(Boolean)[0];
    return first ? `/${first}` : '/';
}

/** @returns {boolean} 보내기를 시도했는지 */
export function track(name, props = {}, win = typeof window === 'undefined' ? null : window) {
    if (!win || !NAMES.has(name)) {
        return false;
    }
    const body = JSON.stringify({ name, props });
    const token = useSession.getState().token;
    try {
        if (token && typeof win.fetch === 'function') {
            win.fetch(`${API_BASE}/events`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
                body,
                keepalive: true,
            }).catch(() => {
                // 이벤트 하나 못 남겨도 화면은 그대로입니다
            });
            return true;
        }
        if (typeof win.navigator?.sendBeacon === 'function') {
            return win.navigator.sendBeacon(`${API_BASE}/events`, new Blob([body], { type: 'application/json' }));
        }
    } catch {
        // 위와 같음
    }
    return false;
}
